// extracted by mini-css-extract-plugin
export var content = "styles-module--content--lPB85";
export var buttons = "styles-module--buttons--uOe0o";